import * as React from 'react';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';
import utils from '../../utils'
export default function CurrencyBasic({
  label = 'Cantidad',
  value,
  onChange,
  name = 'amount',
  required=false,
  locale = 'es-ES',
}) {
  const adminNumberFormat=JSON.parse(utils.getSessionItem('user')).number_format
  const { group: thousandSeparator, decimal: decimalSeparator } = getSeparatorsFromLocale(adminNumberFormat);

  return (
    <NumericFormat
      customInput={TextField}
      required={required}
      label={label}
      name={name}
      value={
        value === undefined || value === null || value === ''
          ? ''
          : (parseInt(value, 10) / 100).toFixed(2)
      }
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      onValueChange={(values) => {
        const numericValue = values.value;
        const valueInCents = numericValue === '' ? '' : Math.round(parseFloat(numericValue) * 100);
        onChange({
          target: {
            name,
            value: valueInCents.toString(),
          },
        });
      }}
    />
  );
}

function getSeparatorsFromLocale(locale) {
  const parts = new Intl.NumberFormat(locale).formatToParts(1234567.89);
  const group = parts.find(p => p.type === 'group')?.value || ',';
  const decimal = parts.find(p => p.type === 'decimal')?.value || '.';
  return { group, decimal };
}
